import { ActionIcon, Group, Text } from "@mantine/core";
import { IconArrowBack, IconMinus, IconPlus, IconX } from "@tabler/icons-react";

import styles from "./GradientHeader.module.css";

export function GradientHeader({
    title,
    onClose,
    onMinimize,
    isMinimized,
    isClosed,
}: {
    title?: string;
    onClose?: () => void;
    onMinimize?: () => void;
    isMinimized?: boolean;
    isClosed?: boolean;
}) {
    return (
        <Group px="sm" py="xs" wrap={"nowrap"} gap={4} className={styles.header} justify={"space-between"}>
            <Text fw={600} size="sm" lineClamp={1}>
                {title}
            </Text>

            <Group gap={0} wrap={"nowrap"}>
                <ActionIcon variant="transparent" onClick={onMinimize} className={styles.headerIcon}>
                    {isMinimized ? <IconPlus size={16} /> : <IconMinus size={16} />}
                </ActionIcon>
                <ActionIcon variant="transparent" onClick={onClose} className={styles.headerIcon}>
                    {isClosed ? <IconArrowBack size={16} /> : <IconX size={16} />}
                </ActionIcon>
            </Group>
        </Group>
    );
}
